module.exports = __webpack_public_path__ + "static/media/darkgrey.718a4415.svg";